import * as React from 'react';

import DesktopNav from './DesktopNav';
import MobileNav from './MobileNav';

import * as styles from './nav.module.scss';

import type {Translations} from '@src/i18n';

export interface NavProps {
  translations?: Translations[];
  nav: NavItem[];
}

interface NavState {
  width: number | null;
}

interface PrimaryNavItem {
  label: {text: string};
  link: {text: string};
}

export interface SubNavItem {
  sub_nav_link_label: {
    text: string;
  };
  sub_nav_link_url: {
    text: string;
  };
}

export interface NavItem {
  primary: PrimaryNavItem;
  items: SubNavItem[];
}

class Nav extends React.Component<NavProps, NavState> {
  constructor(props: NavProps) {
    super(props);

    this.state = {
      width: null,
    };
  }

  componentDidMount() {
    this.setWindowSize();
    window.addEventListener('resize', this.handleWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }

  handleWindowResize = () => {
    this.setWindowSize();
  };

  setWindowSize() {
    this.setState({width: window.innerWidth});
  }

  render() {
    const {translations, nav} = this.props;
    const {width} = this.state;
    const isMobile = width !== null && width < 1200;

    return (
      <div className={styles.nav}>
        {isMobile ? (
          <MobileNav translations={translations} nav={nav} />
        ) : (
          <DesktopNav translations={translations} nav={nav} />
        )}
      </div>
    );
  }
}

export default Nav;
